import React from 'react';
import CTA from '../../CTA';
import BodyText from '../../BodyText';

/** @type import('@contentful/rich-text-react-renderer').NodeRenderer */
export default function InlineEmbeddedEntries(node) {
  switch (node.data.target?.__typename) {
    case 'ContentfulTertiaryCta':
      return <CTA buttonType="tertiary" isInline {...node.data.target} />;
    case 'ContentfulBodyText':
      return <BodyText isInline {...node.data.target} />;
    default:
      return null;
  }
}
